import { apiClient } from "@/api";
import { ApiResponse, PaginatedData } from "@/types";
import { AxiosRequestConfig } from "axios";

export type ICategory = "ai_use_case" | "ax_trend" | "pwc_digital_solutions";
export type IStatus = "scheduled" | "published";

export interface IGetListReq {
  category?: ICategory;
  status?: IStatus;
  search?: string;
  page: number;
  page_size: number;
}

export interface IGetListRes {
  id: string;
  title: string;
  category: ICategory;
  status: IStatus;
  created_by_name: string;
  publish_at: string;
  created_at: string;
  updated_at: string;
}

export interface ICreateArticleReq {
  title: string;
  category: ICategory;
  content: string;
  cover_image: File;
  publish_at?: string;
}

export interface IArticle {
  id: string;
  title: string;
  category: string;
  content: string;
  cover_image_url: string;
  status: IStatus;
  publish_at: string;
  created_by_id: string;
  created_by_name: string;
  updated_by_id: string | null;
  updated_by_name: string | null;
  created_at: string;
  updated_at: string;
}
export const AdminAxNewsService = {
  getList: (params: IGetListReq, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<PaginatedData<IGetListRes>>>(
      "admin/ax-trend-hub/articles",
      { ...config, params },
    );
  },
  create: (data: ICreateArticleReq, force = false, config?: AxiosRequestConfig) => {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("category", data.category);
    formData.append("content", data.content);
    if (data.publish_at) {
      formData.append("publish_at", data.publish_at);
    }
    formData.append("cover_image", data.cover_image);

    return apiClient.post<ApiResponse<IArticle>>(
      `admin/ax-trend-hub/articles${force ? "?force=true" : ""}`,
      formData,
      {
        ...config,
        headers: {
          "Content-Type": "multipart/form-data",
          ...config?.headers,
        },
      },
    );
  },
  getById: (id: string, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<IArticle>>(
      `admin/ax-trend-hub/articles/${id}`,
      config
    );
  },
  update: (id: string, data: Partial<ICreateArticleReq> & { cover_image?: File; updated_at?: string }, config?: AxiosRequestConfig) => {
    const formData = new FormData();

    if (data.title !== undefined) formData.append("title", data.title);
    if (data.category !== undefined) formData.append("category", data.category);
    if (data.content !== undefined) formData.append("content", data.content);
    if (data.publish_at !== undefined) formData.append("publish_at", data.publish_at);
    if (data.cover_image !== undefined) formData.append("cover_image", data.cover_image);
    if (data.updated_at !== undefined) formData.append("updated_at", data.updated_at);

    return apiClient.put<ApiResponse<IArticle>>(
      `admin/ax-trend-hub/articles/${id}`,
      formData,
      {
        ...config,
        headers: {
          "Content-Type": "multipart/form-data",
          ...config?.headers,
        },
      },
    );
  },
  delete: (id: string, config?: AxiosRequestConfig) => {
    return apiClient.delete<ApiResponse<IArticle>>(
      `admin/ax-trend-hub/articles/${id}`,
      config
    );
  },
};
